var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[(!_vm.paymentSuccess)?_c('payment-failed'):_vm._e(),_vm._v(" "),(_vm.paymentSuccess)?_c('payment-success',{attrs:{"order-number":_vm.orderNumber}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }